var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.asesores,"outlined":"","item-text":"option","item-value":"PERNR","label":"Seleccionar Asesor / Zona"},on:{"input":function($event){return _vm.$emit('changeSelectAsesor', _vm.filtro)}},model:{value:(_vm.filtro),callback:function ($$v) {_vm.filtro=$$v},expression:"filtro"}})
}
var staticRenderFns = []

export { render, staticRenderFns }